import React from 'react';
import TicketFieldList from './TicketFieldList';
import PaymentGatewayRateTable from '../PaymentGatewayRateTable';

const hasValue = value => Array.isArray(value) ? value.some(hasValue)
  : value && typeof value === 'object' ? Object.values(value).some(hasValue)
  : value !== '' && value != null;
const environmentFields = environment => [
  { key: 'bo_urls', label: 'Backoffice URLs', value: environment.bo_urls },
  { key: 'api_urls', label: 'API URLs', value: environment.api_urls },
  ...Object.entries(environment).filter(([key]) => !['bo_urls', 'api_urls', 'callback_paths'].includes(key))
    .map(([key, value]) => ({ key, label: key, value })),
  { key: 'callback_paths', label: 'Callback paths', value: environment.callback_paths }
].filter(field => hasValue(field.value));

const ProviderConfigSummary = ({ config = {}, provider }) => (
  <div className="ticket-provider-config">
    {provider?.paymentGateway && (config.selling_rate_rules === null || config.selling_rate === null ? <p className="ticket-muted">Selling rates restricted.</p> :
      <PaymentGatewayRateTable provider={provider} rules={config.selling_rate_rules} defaultRate={config.selling_rate ?? 0} />)}
    <TicketFieldList fields={[
      ...(!provider?.paymentGateway ? [{ label: 'Selling rate', value: config.selling_rate == null ? 'Restricted' : `${config.selling_rate}%` }] : []),
      { label: 'Provider status', value: (config.status || 'draft').replace(/^./, char => char.toUpperCase()) },
      { label: 'Client line', value: config.is_client_line == null ? 'Restricted' : config.is_client_line }
    ]} />
    {['production', 'staging'].map(env => {
      const fields = environmentFields(config.credentials?.[env] || {});
      return <details key={env} className="ticket-details-group">
        <summary>{env === 'production' ? 'Production' : 'Staging'}</summary>
        {fields.length ? <TicketFieldList fields={fields} /> : <p className="ticket-muted">Not provided.</p>}
      </details>;
    })}
    {!!config.group_links?.length && <details className="ticket-details-group">
      <summary>Group links</summary>
      <TicketFieldList fields={config.group_links.map((link, index) => ({ key: String(index), label: link.name || `Link ${index + 1}`, value: link.url }))} />
    </details>}
  </div>
);

export default ProviderConfigSummary;
